import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * TierProOutline icon
 *
 * @category Tier
 */
const TierProOutline = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.593 4.562c1.081-1.164 3.03-.399 3.03 1.19v9.137c0 .24.173.474.414.474h4.573c1.526 0 2.32 1.82 1.281 2.938l-8.484 9.137c-1.081 1.164-3.03.399-3.03-1.19v-9.137c0-.241-.173-.474-.414-.474H8.39c-1.526 0-2.32-1.82-1.281-2.938z M11.25678 13.05377 A0.58498 0.58498 0 0 0 11.68514 14.037 H15.43735 A0.58498 0.58498 0 0 0 16.023 13.45202 V9.41134 C16.023 8.87923 15.37108 8.62355 15.00898 9.01309 z M20.74322 18.94623 A0.58498 0.58498 0 0 0 20.31486 17.963 H16.56265 A0.58498 0.58498 0 0 0 15.977 18.54798 V22.58866 C15.977 23.12077 16.62892 23.37645 16.99102 22.98691 z"
        />
      </svg>
    );
  }
);

TierProOutline.displayName = 'TierProOutline';

export { TierProOutline };
